module.exports = __webpack_public_path__ + "img/arta-small.fa027d4d.png";